module.exports = __webpack_public_path__ + "img/losaprily-reviews.7392dc06.png";